
export default {
	Prayers: {
		SIGNUM_CRUCIS: 'W imię Ojca, i Syna, i Ducha Świętego. Amen.',
		APOSTLES_CREED: 'Wierzę w Boga Ojca wszechmogącego, Stworzyciela nieba i ziemi, i w Jezusa Chrystusa, Syna Jego Jedynego, Pana naszego, który się począł z Ducha Świętego, narodził się z Maryi Panny, umęczon pod Ponckim Piłatem, ukrzyżowan, umarł i pogrzebion, zstąpił do piekieł, trzeciego dnia zmartwychwstał, wstąpił na niebiosa, siedzi po prawicy Boga Ojca wszechmogącego, stamtąd przyjdzie sądzić żywych i umarłych. Wierzę w Ducha Świętego, święty Kościół powszechny, świętych obcowanie, grzechów odpuszczenie, ciała zmartwychwstanie, żywot wieczny. Amen.',
		PATER_NOSTER: 'Ojcze nasz, któryś jest w niebie, święć się imię Twoje, przyjdź królestwo Twoje, bądź wola Twoja jako w niebie, tak i na ziemi. Chleba naszego powszedniego daj nam dzisiaj i odpuść nam nasze winy jako i my odpuszczamy naszym winowajcom i nie wódź nas na pokuszenie, ale nas zbaw ode złego. Amen.',
		AVE_MARIA: 'Zdrowaś Maryjo, łaski pełna, Pan z Tobą. Błogosławionaś Ty między niewiastami i błogosławiony owoc żywota Twojego, Jezus. Święta Maryjo, Matko Boża, módl się za nami grzesznymi, teraz i w godzinę śmierci naszej. Amen.',
		GLORIA: 'Chwała Ojcu, i Synowi, i Duchowi Świętemu, jak była na początku, teraz i zawsze, i na wieki wieków. Amen.',
		ORATIO_FATIMA: 'O mój Jezu, przebacz nam nasze grzechy, zachowaj nas od ognia piekielnego, zaprowadź wszystkie dusze do nieba i dopomóż szczególnie tym, którzy najbardziej potrzebują Twojego miłosierdzia.',
		SALVE_REGINA: 'Witaj Królowo, Matko Miłosierdzia, życie, słodyczy i nadziejo nasza, witaj! Do Ciebie wołamy wygnańcy, synowie Ewy, do Ciebie wzdychamy jęcząc i płacząc na tym łez padole. Przeto, Orędowniczko nasza, one miłosierne oczy Twoje na nas zwróć, a Jezusa, błogosławiony owoc żywota Twojego, po tym wygnaniu nam okaż. O łaskawa, o litościwa, o słodka Panno Maryjo!'
	},

	Ordinals: {
		MYSTERY_1: 'Tajemnica pierwsza',
		MYSTERY_2: 'Tajemnica druga',
		MYSTERY_3: 'Tajemnica trzecia',
		MYSTERY_4: 'Tajemnica czwarta',
		MYSTERY_5: 'Tajemnica piąta'
	},

	Mysteries: {
		JOYFUL: {
			MYSTERY_1: 'Zwiastowanie Najświętszej Maryi Pannie',
			MYSTERY_2: 'Nawiedzenie św. Elżbiety przez Najświętszą Maryję Pannę',
			MYSTERY_3: 'Narodziny Pana Jezusa',
			MYSTERY_4: 'Ofiarowanie w świątyni',
			MYSTERY_5: 'Znalezienie w świątyni'
		},
		SORROWFUL: {
			MYSTERY_1: 'Modlitwa w Ogrójcu',
			MYSTERY_2: 'Ubiczowanie',
			MYSTERY_3: 'Cierniem ukoronowanie',
			MYSTERY_4: 'Droga Krzyżowa',
			MYSTERY_5: 'Ukrzyżowanie i śmierć Pana Jezusa'
		},
		GLORIOUS: {
			MYSTERY_1: 'Zmartwychwstanie',
			MYSTERY_2: 'Wniebowstąpienie',
			MYSTERY_3: 'Zesłanie Ducha Świętego',
			MYSTERY_4: 'Wniebowzięcie Najświętszej Maryi Panny',
			MYSTERY_5: 'Ukoronowanie Najświętszej Maryi Panny na Królową Nieba i Ziemi'
		},
		LUMINOUS: {
			MYSTERY_1: 'Chrzest w Jordanie',
			MYSTERY_2: 'Cud w Kanie Galilejskiej',
			MYSTERY_3: 'Głoszenie Królestwa Bożego i wzywanie do nawrócenia',
			MYSTERY_4: 'Przemienienie Pańskie na górze Tabor',
			MYSTERY_5: 'Ustanowienie Eucharystii'
		}
	},

	Meditations: {
		JOYFUL: {
			MYSTERY_1: 'Oto ja służebnica Pańska, niech mi się stanie według twego słowa.',
			MYSTERY_2: 'A skądże mi to, że Matka mojego Pana przychodzi do mnie?',
			MYSTERY_3: 'Dziś w mieście Dawida narodził się wam Zbawiciel, którym jest Mesjasz, Pan.',
			MYSTERY_4: 'Oto Ten przeznaczony jest na znak, któremu sprzeciwiać się będą.',
			MYSTERY_5: 'Czemuście Mnie szukali? Czy nie wiedzieliście, że powinienem być w tym, co należy do mego Ojca?'
		},
		SORROWFUL: {
			MYSTERY_1: 'Ojcze mój, jeśli to możliwe, niech Mnie ominie ten kielich!',
			MYSTERY_2: 'Wówczas Piłat wziął Jezusa i kazał Go ubiczować.',
			MYSTERY_3: 'Jezus więc wyszedł na zewnątrz, w koronie cierniowej i płaszczu purpurowym. Piłat rzekł do nich: "Oto Człowiek".',
			MYSTERY_4: 'Jeśli kto chce pójść za Mną, niech się zaprze samego siebie, niech weźmie krzyż swój i niech Mnie naśladuje!',
			MYSTERY_5: 'Ojcze, w Twoje ręce powierzam ducha mojego.'
		},
		GLORIOUS: {
			MYSTERY_1: 'Wy się nie bójcie! Gdyż wiem, że szukacie Jezusa Ukrzyżowanego. Nie ma Go tu, bo zmartwychwstał, jak powiedział. Chodźcie, zobaczcie miejsce, gdzie leżał.',
			MYSTERY_2: 'W domu Ojca mego jest mieszkań wiele. Gdyby tak nie było, to bym wam powiedział. Idę przygotować wam miejsce.',
			MYSTERY_3: 'Ukazały się im też języki jakby z ognia, które się rozdzieliły, i na każdym z nich spoczął jeden. I wszyscy zostali napełnieni Duchem Świętym.',
			MYSTERY_4: 'Ojcze, chcę, aby także ci, których Mi dałeś, byli ze Mną tam, gdzie Ja jestem.',
			MYSTERY_5: 'Zwycięzcy dam zasiąść ze Mną na moim tronie.'
		},
		LUMINOUS: {
			MYSTERY_1: 'A gdy Jezus został ochrzczony, głos z nieba mówił: "Ten jest mój Syn umiłowany, w którym mam upodobanie".',
			MYSTERY_2: 'Wtedy Matka Jego powiedziała do sług: "Zróbcie wszystko, cokolwiek wam powie".',
			MYSTERY_3: 'Czas się wypełnił i bliskie jest królestwo Boże. Nawracajcie się i wierzcie w Ewangelię!',
			MYSTERY_4: 'Jezus wziął z sobą Piotra, Jana i Jakuba i wyszedł na górę. Gdy się modlił, wygląd Jego twarzy się odmienił, a Jego odzienie stało się lśniąco białe. A z obłoku odezwał się głos: "To jest Syn mój, Wybrany, Jego słuchajcie!"',
			MYSTERY_5: 'Jezus wstał od wieczerzy i złożył szaty. A wziąwszy prześcieradło nim się przepasał. Potem nalał wody do miednicy i zaczął umywać uczniom nogi i ocierać prześcieradłem, którym był przepasany.'
		}
	}
};
